export const GET_SALES = "GET_SALES";